(function(){
  var KEY='altair_cart_choice_deadline';
  var DURATION=15*60*1000;
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  function read(){try{return Number(sessionStorage.getItem(KEY))||0;}catch(_){return 0;}}
  function write(value){try{if(value)sessionStorage.setItem(KEY,String(value));else sessionStorage.removeItem(KEY);}catch(_){}}
  function render(){
    var left=Math.max(0,Math.ceil((read()-Date.now())/1000));
    document.querySelectorAll('[data-alt-cart-timer-header],[data-alt-cart-timer-drawer]').forEach(function(box){
      box.hidden=left===0;
      var time=box.querySelector('[data-alt-cart-time]');
      if(time){time.textContent=String(Math.floor(left/60)).padStart(2,'0')+':'+String(left%60).padStart(2,'0');}
    });
  }
  function start(){
    if(read()<=Date.now())write(Date.now()+DURATION);
    render();
  }
  function syncCart(){
    fetch(root+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'},cache:'no-store'}).then(function(response){return response.json();}).then(function(cart){
      if(cart.item_count>0&&read()<=Date.now())start();
      if(cart.item_count===0)write(0);
      render();
    }).catch(function(){render();});
  }
  var originalFetch=window.fetch;
  window.fetch=function(resource,options){
    var url=typeof resource==='string'?resource:(resource&&resource.url)||'';
    var result=originalFetch.apply(this,arguments);
    if(/\/cart\/add(?:\.js)?(?:\?|$)/.test(url))result.then(function(response){if(response.ok)start();}).catch(function(){});
    if(/\/cart\/(?:change|update|clear)(?:\.js)?(?:\?|$)/.test(url))result.then(function(response){if(response.ok)setTimeout(syncCart,200);}).catch(function(){});
    return result;
  };
  document.addEventListener('lume-cart:refreshed',syncCart);
  document.addEventListener('DOMContentLoaded',function(){syncCart();setInterval(render,1000);});
})();
